import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  makeStyles,
  Grid,
  Button,
  Paper,
  Typography
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import AddCircleIcon from '@material-ui/icons/AddCircle';

import {
  Select
} from '../common/fields';


const useStyles = makeStyles((theme) => ({
  row: {
    backgroundColor: theme.palette.background.sidebar,
    margin: theme.spacing(2,0,2,0),
    padding: '12px'
  },
  clearBtn: {
    marginRight: theme.spacing(2)
  },
  actions: {
    marginTop: theme.spacing(3)
  },
  newRowBtn: {
    textTransform: 'none',
    '& .MuiSvgIcon-root': {
      marginRight: '10px'
    }
  }
}));


const ItemLines = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    items = [],
    vehicleTypes = [],
    handleChange,
    disabled,
    seasons = []
  } = props;

  const addNew = () => {
    const newData = [
      ...items,
      {vehicleType: '', season: ''}
    ];

    handleChange(newData);
  };

  const remove = index => event => {
    const newData = items.filter((row, rowIndex) => rowIndex !== index);

    handleChange(newData);
  };

  const edit = index => event => {
    const newItem = {[event.target.name]: event.target.value};
    const newData = items.map((oldItem, rowIndex) => (rowIndex === index) ? {...oldItem, ...newItem} : oldItem);
    handleChange(newData);
  };

  return (
    <>
      {items.map((item, index) =>
        <Paper key={index} elevation={0} className={classes.row}>
          <Grid container spacing={3}>
            <Grid item xs={5}>
              <Select
                label={t('itemFamily:vehicleType')}
                name="vehicleType"
                value={item.vehicleType}
                options={vehicleTypes.map(item => ({label: item.name, value: item.code}))}
                onChange={edit(index)}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={5}>
              <Select
                label={t('itemFamily:season')}
                name="season"
                value={item.season}
                options={seasons.map(item => ({label: item.name, value: item.code}))}
                onChange={edit(index)}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={2} container justifyContent="flex-end">
              <Button onClick={remove(index)} aria-label={t('itemFamily:removeItemLine')} title={t('itemFamily:removeItemLine')} disabled={disabled}>
                <ClearIcon />
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}
      <Button onClick={addNew} className={classes.newRowBtn} disabled={disabled}>
        <AddCircleIcon color={disabled ? 'inherit' : 'primary'} />
        <Typography variant="caption">
          {t('itemFamily:addItemLine')}
        </Typography>
      </Button>
    </>
  );
};

ItemLines.propTypes = {
  items: PropTypes.array,
  handleChange: PropTypes.func,
  vehicleTypes: PropTypes.array,
  seasons: PropTypes.array,
  disabled: PropTypes.bool
};

export default ItemLines;
